module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "technological"
    }
  }, [_c('headersection', {
    attrs: {
      "headdata": _vm.techheader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.technologicalStack), function(tech) {
    return _c('div', {
      staticClass: "column is-narrow is-12-mobile is-4-tablet is-2-desktop"
    }, [_c('article', {
      staticClass: "tile is-child notification with-shadow",
      attrs: {
        "id": tech.class
      }
    }, [_c('tileArticle', {
      attrs: {
        "articleInfo": tech
      }
    })], 1)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24dee523!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/technological.vue
// module id = 269
// module chunks = 2